import {Injectable} from "@angular/core";
import {throwError} from "rxjs";
import {LoaderService} from "./loader.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {AuthenticationService, EXTERNAL_LOGIN_URL, LOGIN_URL} from "./authentication.service";
import {TOAST_STATE, ToastService} from "./toast.service";
import {TranslocoService} from "@ngneat/transloco";

@Injectable({ providedIn:'root' })
export class ErrorService {

  constructor(private loaderService: LoaderService, private authenticationService: AuthenticationService,
              private toastService: ToastService, private translocoService: TranslocoService) {
  }

  handleError(error: any) {
    this.loaderService.dismissLoading();
    if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized
      && !error.url?.includes(LOGIN_URL) && !error.url?.includes(EXTERNAL_LOGIN_URL)) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.session.timeout'));
      this.authenticationService.logout();
    } else if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.PayloadTooLarge) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.payloadTooLarge'));
    } else if (error instanceof HttpErrorResponse && error.status !== HttpStatusCode.Unauthorized) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.error'));
    }
    return throwError(error);
  }
}
